<div class="flex flex-col justify-center items-center h-full bg-gradient-to-t from-gray-200 to-gray-300">
    <h1 class="text-primary-500 text-9xl font-bold">404</h1>
    <p class="text-primary-600">Page not found, please return to previous page!</p>
</div>
